<template>
  <div>
    <v-expand-transition v-for="(plaintiff, index) in plaintiffs" :key="index">
      <v-card
        class="ma-auto"
        max-width="800px"
        shaped
        style="border: 2px solid black"
      >
        <!-- <v-card
        style="border-color: #073d45; background-color: black;"
        class="ma-2 ml-4 white--text font-weight-light"
        shaped
        outlined
      > -->
        <v-row>
          <v-flex>
            <v-card-text
              class="title ml-3"
              @click="viewPlaintiff(index)"
              align="left"
              >{{ plaintiff.fullName }}</v-card-text
            >
          </v-flex>
          <v-spacer @click="viewPlaintiff(index)"></v-spacer>

          <!-- <v-flex> -->
          <v-card-actions class="mr-2">
            <!-- <v-btn
              class="ma-1"
              text
              small
              rounded
              outlined
              color="yellow"
              @click="openDiscoveryComponent(plaintiff)"
              v-if="showPlaintiff == index"
              >discovery</v-btn
            > -->
            <v-icon
              v-if="plaintiff.formList && plaintiff.formList.length > 0"
              color="green"
              >mdi-check</v-icon
            >
            <div v-if="plaintiff.formList && plaintiff.formList.length > 0">
              form sent
            </div>
            <v-btn
              class="ma-1"
              text
              small
              rounded
              color="secondary"
              @click="viewPlaintiff(index)"
              v-if="showPlaintiff !== index"
              >view</v-btn
            >
            <v-btn
              class="ma-1"
              small
              outlined
              color="secondary"
              rounded
              @click="showPlaintiff = null"
              v-if="showPlaintiff == index"
              >hide</v-btn
            >
            <v-btn
              small
              text
              rounded
              outlined
              color="red"
              @click="deletePlaintiff(plaintiff)"
              class="ma-1"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
          <!-- </v-flex> -->
        </v-row>
        <hr />
        <v-expand-transition class="ma-2">
          <div v-if="showPlaintiff === index">
            <!-- <div>name: {{ plaintiff.fullName }}</div>
            <div>date of birth: {{ plaintiff.dateOfBirth || "none" }}</div> -->
            <div>
              <app-view-plaintiff
                :matter="matter"
                :user="user"
                :plaintiff="plaintiff"
              ></app-view-plaintiff>
            </div>
          </div>
        </v-expand-transition>
      </v-card>
    </v-expand-transition>
  </div>
  <!-- <div>HELLO</div> -->
  <!-- </div> -->
</template>

<script>
/**
 * this component gets the matter object and displays a list of plaintiffs
 * with a ViewPlaintiff component for each plaintiff in the matter.
 */

import firebase from "firebase";
import * as moment from "moment";

export default {
  props: ["matter", "user"],
  data() {
    return {
      // plaintiffs: this.matter.plaintiffs
      // selectedPlaintiffs: []
      showPlaintiff: null
    };
  },
  computed: {
    plaintiffs() {
      return this.matter.plaintiffs;
      // let plaintiffs = this.matter.plaintiffs;
      // plaintiffs.forEach(plaintiff => {
      //   const foundPlaintiff = plaintiffs.find(
      //   plaintiff => plaintiff.plaintiffSlug === payload.matterSlug
      // );
      // if (foundMatter !== null && foundMatter !== undefined) {
      //   return;
      // } else {
      //   state.matters.push(payload);
      // }
      //   if ()
      // })
    }
  },
  methods: {
    // openDiscoveryComponent(plaintiff) {
    //   let windowName = `${plaintiff.fullName}`;
    //   let windowLink = `${window.location.origin}/matters/${this.matter.matterSlug}/${plaintiff.partySlug}/discovery`;
    //   window.open(windowLink, windowName);
    // },
    viewPlaintiff(index) {
      // console.log(plaintiff);
      this.showPlaintiff = index;
      // let payload = {
      //   partyType: "plaintiff",
      //   party: plaintiff
      // };
      // this.$store.dispatch("viewPlaintiff", plaintiff);
    },
    deletePlaintiff(plaintiff) {
      // let newArray = Array.from(this.matter.plaintiffs);

      // //remove the doc from the array
      // newArray.splice(index, 1);
      // console.log("newArray", newArray);
      // console.log("oldArray", this.matter.plaintiffs);
      if (
        window.confirm(
          `are you sure you want to permanently delete this plaintiff: ${plaintiff.fullName}`
        )
      ) {
        let activity = {
          content: `${this.user.email} removed a plaintiff from ${this.matter.caseName}, named ${plaintiff.fullName}.`,
          matterID: this.$route.params.id,
          date: moment().format("MMMM Do YYYY, h:mm:ss a"),
          user: { email: this.user.email }
        };
        firebase
          .firestore()
          // .collection("firms")
          // .doc(this.user.firmSlug)
          .collection("matters")
          .doc(this.matter.matterSlug)
          .update({
            plaintiffs: firebase.firestore.FieldValue.arrayRemove(plaintiff),
            activities: firebase.firestore.FieldValue.arrayUnion(activity)
          })
          .then(() => {
            console.log("success");
            if (plaintiff.formList) {
              plaintiff.formList.forEach(item => {
                firebase
                  .firestore()
                  // .collection("firms")
                  // .doc(this.user.firmSlug)
                  .collection("matters")
                  .doc(this.matter.matterSlug)
                  .collection("clients")
                  .doc(plaintiff.partySlug)
                  .collection("formList")
                  .doc(item.id)
                  .delete()
                  .then(() => {
                    console.log("Successfully deleted client formList Item");

                    // let activity = {
                    //   content: `${this.user.email} removed a plaintiff from ${this.matter.caseName}, named ${plaintiff.fullName}.`,
                    //   mattedID: this.$route.params.id,
                    //   date: moment().format("MMMM Do YYYY, h:mm:ss a")
                    // };
                    //   let activityPayload = {
                    //     activity,
                    //     firmSlug: this.user.firmSlug
                    //   };

                    // // firebase
                    // //   .firestore()
                    // //   .collection("firms")
                    // //   .doc(this.user.firmSlug)
                    // //   .update({
                    // //     activities: activity
                    // //   });
                    //           this.$store.dispatch("addFirmActivity", activityPayload);
                  })
                  .catch(error => {
                    console.log("Error deleting client formList Item", error);
                  });
              });
            }

            firebase
              .firestore()
              // .collection("firms")
              // .doc(this.user.firmSlug)
              .collection("matters")
              .doc(this.matter.matterSlug)
              .collection("clients")
              .doc(plaintiff.partySlug)
              .delete()
              .then(() => {
                console.log("Successfully deleted client document");
              })
              .catch(error => {
                console.log("Error deleting client:", error);
              });
          })
          .then(() => {
            //deleteUser
            const deleteUserAuth = firebase
              .functions()
              .httpsCallable("deleteUserAuth");
            deleteUserAuth({
              userSlug: plaintiff.partySlug
            });

            // let activity = {
            //   content: `${this.user.email} removed a plaintiff from ${this.matter.caseName}, named ${plaintiff.fullName}.`,
            //   matterID: this.$route.params.id,
            //   date: moment().format("MMMM Do YYYY, h:mm:ss a")
            // };
            // let firmRef = firebase
            //   .firestore()
            //   .collection("firms")
            //   .doc(this.user.firmSlug);
            // firmRef.get().then(firm => {
            //   let data = firm.data();
            //   console.log("data", data);
            // });

            // firebase
            //   .firestore()
            //   .collection("firms")
            //   .doc(this.user.firmSlug)
            //   .update({
            //     activities: firebase.firestore.FieldValue.arrayUnion(activity)
            //   });
            // let activityPayload = {
            //   activity,
            //   firmSlug: this.user.firmSlug
            // };

            // this.$store.dispatch("addFirmActivity", activityPayload);
            this.$store.dispatch("clearPlaintiff");
          })
          .then(() => {
            // let activity = {
            //   content: `${this.user.email} removed a plaintiff from ${this.matter.caseName}, named ${plaintiff.fullName}.`,
            //   matterID: this.$route.params.id,
            //   date: moment().format("MMMM Do YYYY, h:mm:ss a"),
            //   user: this.user
            // };
            let activityPayload = {
              activity,
              firmSlug: this.user.firmSlug
            };

            // firebase
            //   .firestore()
            //   .collection("firms")
            //   .doc(this.user.firmSlug)
            //   .update({
            //     activities: activity
            //   });
            this.$store.dispatch("addFirmActivity", activityPayload);
          })
          .catch(error => {
            console.log("Error deleting user:", error);
          });
      }
    }
  },
  created() {
    console.log("plaintiffs:", this.plaintiffs);
  }
};
</script>

<style lang="scss" scoped></style>
